import React, { useState, useEffect } from 'react'
import { Form } from 'react-bootstrap'
import { setExportDocumentParam } from '../../redux/actions/exportDocumentActions'
import { connect } from 'react-redux'
import StaffApi from '../../api/StaffApi'

const api = new StaffApi();

const Responsibles = ({ setExportDocumentParam }) => {

  const [listResponsibles, setLisResponsibles] = useState([])

  const handleChange = (e) => {
    setExportDocumentParam({responsible: e.target.value})
  }

  useEffect(() => {
    api.searchByRole('Servicios Escolares')
      .then( data =>  {
        setLisResponsibles(data)
      })
      .catch( error => console.error(error))
  }, [])

  return (
    <Form.Group controlId="exampleForm.SelectCustom">
      <Form.Label>Selecionar encargado</Form.Label>
      <Form.Control as="select" custom onChange={ handleChange }>
        <option value={-1}>Ninguno</option>
        {
          listResponsibles.map( ({slug, nombre, primer_apellido},key) => <option key={key} value={slug}>{`${nombre} ${primer_apellido}`}</option>)
        }
      </Form.Control>
    </Form.Group>
  )
}

const mapDispatchToProps = {
  setExportDocumentParam
}

export default connect(null, mapDispatchToProps)(Responsibles)